
import axios from 'axios';
import service from '../service';

import { isNotLogin } from '../index';
import redirectLogin from '../redirectLogin';

interface PageData {
  page?: number
  size?: number
}
export interface WorksItem {
  id: string;
  name: string;
  imgUrl: string;
  introduction: string;
  studyLinkUrl: string;
  codeLanguage: string;
  videoUrl: string;
  courseLinkUrl: string;
}

export interface MyStatics {
  worksNum: number;
  viewNum: number;
  praiseNum: number;
  enshrinesNum: number;
  forkNum: number;
  nickName: string;
  img: string;
  userId: string
  inBlacklist: boolean // 是否在黑名单中
  [key: string]: any // TODO 这么写有点奇怪
}

export function fetchListData(api: string, data: PageData, inData = false) {
  return service.get(api, {
    params: data
  }).then((ret: any) => {

    if(inData) {
      return {
        list: (Array.isArray(ret?.data?.dataList) ? ret?.data?.dataList : []),
        total: ret?.data?.totalCount as number,
        user: ret?.user || {},
        inBlacklist: ret?.data?.inBlacklist || false
      }
    }

    return {
      list: (Array.isArray(ret.dataList) ? ret.dataList : []),
      total: ret.totalCount as number,
      user: ret?.user || {},
    }
  }, (err: any) => {
    if (isNotLogin(err)) {
      redirectLogin()
    }
    throw err
  })
}

interface UserSpecificDetail {
  encryptionUserId: string
  image: string
  mobile: string
  name: string
  userId: string
  hasCourse: 0 | 1 // 是否拥有课程：0-否 1-是 已弃用
  userIdentity: string
  courseType: string
}

const GetUserSpecificDetailsApi = `${process.env.NEXT_PUBLIC_OJ_API_HOST}api/user/info`

// 获取用户的是否购课、购课类型等信息
export const getUserSpecificDetails = (
  headers = {}
): Promise<UserSpecificDetail> => {
  let api = GetUserSpecificDetailsApi
  if (typeof location !== 'undefined') {
    api = api.replace(/^https?:/, location.protocol)
  }

  return axios
    .get(api, { headers, withCredentials: true })
    .then((res) => res.data.data)
}




